// noinspection DuplicatedCode

import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";
import { tanggalLokal } from "./tanggalLokal";

let user = JSON.parse(localStorage.getItem("user"));

// API


export const getSpecCuti = createAsyncThunk(
    "cutiTransaksi/getSpecCuti",
    async ({TransaksiApprovalID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TransaksiApprovalID", TransaksiApprovalID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSpecCuti',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getCutiTransaksi = createAsyncThunk(
    "cutiTransaksi/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getCuti',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)


export const getCutiTransaksiMandiri = createAsyncThunk(
    "UpdateCutiSelf/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", user.Nik);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getCuti',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const insertCutiTransaksi = createAsyncThunk(
    "cutiTransaksi/insert",
    async ({Nik, JenisCuti, KeperluanCuti, Pengganti, TanggalMulai, TanggalAkhir, Tiket}, thunkAPI) => {
        let formData = new FormData();
        formData.append("Nik", Nik);
        formData.append("JenisCuti", JenisCuti);
        formData.append("KeperluanCuti", KeperluanCuti);
        formData.append("Pengganti", Pengganti);
        formData.append("TanggalMulai", tanggalLokal(TanggalMulai));
        formData.append("TanggalAkhir", tanggalLokal(TanggalAkhir));
        formData.append("Tiket", Tiket);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertCuti',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)


export const InsertCutiSelf = createAsyncThunk(
    "insertCutiSelf/insert",
    async ({JenisCuti, KeperluanCuti, Pengganti, TanggalMulai, TanggalAkhir, Tiket}, thunkAPI) => {
        let formData = new FormData();
        formData.append("JenisCuti", JenisCuti);
        formData.append("KeperluanCuti", KeperluanCuti);
        formData.append("Pengganti", Pengganti);
        formData.append("TanggalMulai", TanggalMulai);
        formData.append("TanggalAkhir", TanggalAkhir);
        formData.append("Tiket", Tiket);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertCutiSelf',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateCutiTransaksi = createAsyncThunk(
    "cutiTransaksi/update",
    async ({TCutiID, Nik, JenisCuti, KeperluanCuti, Pengganti, TanggalMulai, TanggalAkhir, Tiket}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TCutiID", TCutiID);
        formData.append("Nik", Nik);
        formData.append("JenisCuti", JenisCuti);
        formData.append("KeperluanCuti", KeperluanCuti);
        formData.append("Pengganti", Pengganti);
        formData.append("TanggalMulai", tanggalLokal(TanggalMulai));
        formData.append("TanggalAkhir", tanggalLokal(TanggalAkhir));
        formData.append("Tiket", Tiket);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateCuti',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateCutiSelf = createAsyncThunk(
    "updateCutiSelf/update",
    async ({TCutiID, Nik, JenisCuti, KeperluanCuti, Pengganti, TanggalMulai, TanggalAkhir, Tiket}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TCutiID", TCutiID);
        formData.append("JenisCuti", JenisCuti);
        formData.append("KeperluanCuti", KeperluanCuti);
        formData.append("Pengganti", Pengganti);
        formData.append("TanggalMulai", TanggalMulai);
        formData.append("TanggalAkhir", TanggalAkhir);
        formData.append("Tiket", Tiket);

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateCutiSelf',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const kirimCutiTransaksi = createAsyncThunk(
    "cutiTransaksi/kirim",
    async ({TCutiID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TCutiID", TCutiID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'kirimCuti',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            return thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getCutiReport = createAsyncThunk(
    "getCutiReport/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/cuti/lap',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const getCutiReportDetail = createAsyncThunk(
    "getCutiReportDetail/get",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/cuti/lap/detail',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const resetCutiSlice = createAsyncThunk(
    "resetCutiSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
export const resetCutiDetailSlice = createAsyncThunk(
    "resetCutiDetailSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
//INIT
const initialState = {
    message: "",
    SpecCutiData: [],
    isSpecCutiFetching: false,
    isSpecCutiSuccess: false,
    isSpecCutiError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
    report: [],
    reportDetail: null,
    isGetReport: false,
    isGetReportDetail: false,

};


//SLICES
export const cutiTransaksiSlice = createSlice({
    name: "cutiTransaksi",
    initialState,
    reducers: {},
    extraReducers: {
        // GET
        [getCutiReport.fulfilled]: (state, {payload}) => {
            state.report = payload.data;
            state.isGetReport = true;
            state.message = payload.message;
            return state;
        },
        [getCutiReport.rejected]: (state, {payload}) => {
            state.isGetReport = false;
        },
        [getCutiReport.pending]: (state) => {
            state.isGetReport = false;
        },

        [getCutiReportDetail.fulfilled]: (state, {payload}) => {
            if (payload) {
                state.reportDetail = payload.data;
                state.message = payload.message;
            }
            state.isGetReportDetail = true;
            return state;
        },
        [getCutiReportDetail.rejected]: (state, {payload}) => {
            state.isGetReportDetail = false;
        },
        [getCutiReportDetail.pending]: (state) => {
            state.isGetReportDetail = false;
        },
        [resetCutiDetailSlice.pending]: (state) => {
            state.isGetReportDetail = false;
        },
        [getSpecCuti.fulfilled]: (state, {payload}) => {
            state.SpecCutiData = payload.data[0];
            state.isSpecCutiSuccess = true;
            state.message = payload.message;
            return state;
        },
        [getSpecCuti.rejected]: (state, {payload}) => {
            state.isSpecCutiFetching = false;
        },
        [getSpecCuti.pending]: (state) => {
            // Buang data dokumen sebelumnya agar popup tak menampilkan cuti orang lain saat dokumen baru dimuat.
            state.isSpecCutiSuccess = false;
            state.SpecCutiData = {};
            state.isSpecCutiFetching = false;
        },

        [getCutiTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getCutiTransaksi.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getCutiTransaksi.pending]: (state) => {
            state.isGetFetching = true;
        },

        [getCutiTransaksiMandiri.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getCutiTransaksiMandiri.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getCutiTransaksiMandiri.pending]: (state) => {
            state.isGetFetching = true;
        },


        // INSERT
        [insertCutiTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertCutiTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertCutiTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // INSERT
        [InsertCutiSelf.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [InsertCutiSelf.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [InsertCutiSelf.pending]: (state) => {
            state.isInsertFetching = true;
        },


        // KIRIM
        [kirimCutiTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            return state;
        },
        [kirimCutiTransaksi.rejected]: (state) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
        },
        [kirimCutiTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },

        // UPDATE
        [updateCutiTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateCutiTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateCutiTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },


        // UPDATE
        [updateCutiSelf.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateCutiSelf.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateCutiSelf.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const cutiTransaksiSelector = (state) => state.cutiTransaksi;
